import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-model/views/views";
import * as z from "zod";

export const createPriorityBomPickSession = {
  name: "createPriorityBomPickSession" as const,
  input: z.object({
    locationId: z.string(),
    stationId: z.string().optional(),
    targetWorkOrderCount: z.number().int().positive(),
    filterGroup: FilterGroupSchema.nullish(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
  }),
  output: z.object({
    sessionId: z.string(),
    batchCount: z.number(),
    workOrderCount: z.number(),
  }),
};
